module.exports = __webpack_public_path__ + "static/media/cements_ultragold.fd559309.jfif";